module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=3.49"},{"quantity":0.03,"color":"#91E3AD","label":"3.49 - 4.31"},{"quantity":0.06,"color":"#DEFFB0","label":"4.31 - 5.12"},{"quantity":0.01,"color":"#FFE68C","label":"5.12 - 6.14"},{"quantity":9,"color":"#FF9982","label":"6.14 - 7.72"},{"quantity":12,"color":"#FF4D30","label":"7.72 - 1.419"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/city_mme_1981_2016_lcr_100_wheat.json
// module id = 6YwJ
// module chunks = 171